export default {
    clientId: 'ApplicationFormPrototype',
}